import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import withCacheClient from '@cred/shared/hoc/withCacheClient'

import DisclosureQuery from './graphql/queries/disclosure'
import FacadeDisclosure from './components/facade'

class Disclosure extends PureComponent {
  static propTypes = {
    slug: PropTypes.string, // Disclosure slug to be fetched from disclosures-api.
    disclosure: PropTypes.object, // Object disclosure to be rendered when using "withDisclosure" method.
    type: PropTypes.string, // Disclosure type.
    variables: PropTypes.object, // Variables to be rendered.
    id: PropTypes.string, // Checkbox id.
    validate: PropTypes.func, // Used to validate checkbox disclosures.
    child: PropTypes.bool, // Indicates if it is a child disclosure (used internally).
    className: PropTypes.string, // Add a classname to the main component.
    required: PropTypes.bool, // Require the disclosure to be loaded to submit the form. Requires a reduxForm.
    showError: PropTypes.bool,
  }

  static defaultProps = {
    id: null,
    name: null,
    slug: null,
    disclosure: null,
    type: 'none',
    variables: {},
    validate: () => {},
    child: false,
    className: null,
    required: true,
    showError: true,
  }

  static displayName = 'Disclosure'

  get isRequired() {
    return !this.props.child ? this.props.required : false
  }

  renderFacade(disclosure) {
    const {
      variables,
      type,
      name,
      id,
      validate,
      child,
      actions,
      className,
      onChange,
      scrollRequiredProps,
      errorMessage,
      ctaText,
      showError,
    } = this.props

    return (
      <FacadeDisclosure
        {...{
          disclosure,
          variables,
          type,
          name,
          id,
          validate,
          child,
          actions,
          className,
          onChange,
          scrollRequiredProps,
          errorMessage,
          ctaText,
          showError,
        }}
      />
    )
  }

  renderLoad() {
    const { slug } = this.props
    const required = this.isRequired

    return (
      <DisclosureQuery slug={slug} name={slug} required={required}>
        {disclosure => this.renderFacade(disclosure)}
      </DisclosureQuery>
    )
  }

  render() {
    const { disclosure } = this.props

    return disclosure ? this.renderFacade(disclosure) : this.renderLoad()
  }
}

export { Disclosure as DisclosureNoHoc }

export default withCacheClient(Disclosure)
